import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Row } from '../type';
import { CodeBlock } from './CodeBlock';

type PropsInfoBlock = {
  rows: Row[];
  additionalMessage?: string;
};

export default function InfoBlock({ rows, additionalMessage }: PropsInfoBlock) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      {rows
        .filter(i => Boolean(i.value))
        .map((row, index) => (
          <div
            key={row.label}
            className={classNames('flex justify-between', {
              'mt-2': index > 0,
            })}
          >
            <span className="vs-label-md-medium ">{row.label}:</span>
            <span className="vs-label-sm-medium text-vs-base-content text-right">
              {row.value}
            </span>
          </div>
        ))}
      {Boolean(additionalMessage) && (
        <div className="flex flex-col mt-2">
          <span className="vs-label-md-medium">
            {t('shared:dialog.unexpected_err.label.message', {
              defaultValue: `Message`,
            })}
            :
          </span>
          <CodeBlock>{additionalMessage}</CodeBlock>
        </div>
      )}
    </div>
  );
}
